import { AssetSvgProps } from "../../../shared/assets"

export const defaultColors = {
    "col1n": "#E2FFE2"
}
function SkiMak028({ colors = defaultColors, className, onClick, outerTransform, transform, startDrag }: AssetSvgProps) {
    return (
        <g transform={outerTransform}><g className={className} onClick={onClick} transform={transform} onMouseDown={startDrag} onTouchStart={startDrag}><defs>
                <path
                    fill={colors.col1n}
                    d="M171.4 88.35q1.25-5.05 2.15-9.8Q180 31 150.85 12.05q-.85-.5-1.75-.95-8.25-4.4-18.75-6.9-40.5-7.85-80.95-.95-57 11.85-48.2 76.5.8 4.15 1.9 8.6.6 2.4 1.25 4.65 2.7 8 5.85 13.65 17.05 29.7 49.45 41.3 26.6 8 55.2 0 32.45-11.6 49.45-41.3 3.15-5.65 5.85-13.65.65-2.25 1.25-4.65z"
                    id="SkiMak028__Symbol_35_0_Layer0_0_FILL"
                />
            </defs>
            <use
                xlinkHref="#SkiMak028__Symbol_35_0_Layer0_0_FILL"
                transform="translate(105.15 95.3)"
                id="SkiMak028__col1n"
            />
        </g></g>
    )
}
export default SkiMak028
